import React from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

export const TextEditor = ({ title, input }) => {
  const [text, setText] = React.useState("");

  const handleChange = (value) => {
    setText(value);
    const buffer = new Buffer(value);
    const base64data = buffer.toString("base64");
    return input.onChange(base64data);
  };

  const modules = {
    toolbar: [
      [
        { "header": [1, 2, false] }
      ],
      [
        "bold",
        "italic",
        "underline",
        "strike",
        "blockquote"
      ],
      [
        { "list": "ordered" },
        { "list": "bullet" },
        { "indent": "-1" },
        { "indent": "+1" },
        { 'align': ['', 'right', 'center', 'justify'] },
        "link"
      ],
    ]
  };

  const formats = [
    "header",
    "bold",
    "italic",
    "underline",
    "strike",
    "blockquote",
    "list",
    "bullet",
    "indent",
    "align",
    "link"
  ];

  return (
    <div>
      <p>{title}</p>
      <ReactQuill
        theme="snow"
        style={{ minHeight: 200 }}
        modules={modules}
        formats={formats}
        value={text}
        onChange={handleChange}
      />
    </div>
  );
};
